import React from "react";
import { Icon, Link, Stack, Text } from "@bookingcom/bui-react";
import { t, useI18n } from "@bookingcom/lingojs-react";
import { InfoSignIcon } from "@bookingcom/bui-assets-react/streamline";
import useGetFlightsRankingUrl from "../../../hooks/useGetFlightsRankingUrl";
import { isSirfAvailable } from "../../../store/selectors/sirf";
import { useSelector } from "react-redux";
import { getSubsidizedFares } from "../../../store/flightDetails/selectors";

const AlternativeFaresLegalMessages = ({
  active = false,
  isSirfActive
}: {
  active: boolean;
  isSirfActive?: boolean;
}) => {
  const i18n = useI18n();
  const flightsRankingUrl = useGetFlightsRankingUrl();
  const subsidizedFares = useSelector(getSubsidizedFares);

  if (!active) {
    return null;
  }

  const hasSirf = isSirfActive ?? isSirfAvailable(subsidizedFares || []);

  const sirfMessage = hasSirf ? (
    <Stack key="sirf" direction="row" gap={2} alignItems="center">
      <Icon color="neutral_alt" svg={InfoSignIcon} />
      <Stack.Item grow={true} shrink={true}>
        <Text color="neutral_alt">{i18n.trans(t("flights_bp_failed_alternative_disclaimer_sirf"))}</Text>
      </Stack.Item>
    </Stack>
  ) : undefined;

  const ranking = (
    <Stack key="ranking" direction="row" gap={2} alignItems="center">
      <Icon color="neutral_alt" svg={InfoSignIcon} />
      <Stack.Item grow={true}>
        <Stack direction="row" gap={1} alignItems="center">
          <Stack.Item shrink={true}>
            <Text color="neutral_alt">{i18n.trans(t("flights_bp_failed_alternative_legal_results_dsa"))}</Text>
          </Stack.Item>
          <Link
            href={flightsRankingUrl}
            text={i18n.trans(t("flights_bp_failed_alternative_legal_results_dsa_cta"))}
            attributes={{
              target: "_blank",
              rel: "noopener noreferrer",
              "aria-label": i18n.trans(t("a11y_flights_failed_alternative_dsa_cta_open"))
            }}
          />
        </Stack>
      </Stack.Item>
    </Stack>
  );

  const offers = (
    <Stack key="offers" direction="row" gap={2} alignItems="center">
      <Icon color="neutral_alt" svg={InfoSignIcon} />
      <Stack.Item grow={true} shrink={true}>
        <Text color="neutral_alt">{i18n.trans(t("flights_bp_failed_alternative_legal_availability_message"))}</Text>
      </Stack.Item>
    </Stack>
  );

  const availableMessages = [sirfMessage, ranking, offers].filter((i): i is JSX.Element => Boolean(i));

  return availableMessages.length > 0 ? <Stack gap={2}>{availableMessages}</Stack> : null;
};

export default AlternativeFaresLegalMessages;
